import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import {
  ButtonSquare,
  Dropdown,
  Icon,
  SwitchGridListValue,
} from '../../../shared/ui';

import { FC, useMemo } from 'react';
import { IconMap } from '../../../shared/sprite';
import { cn } from '@distribute/frontend/utils';
import { GetCallResponse } from '@distribute/shared/api-types/call';
import { callModel } from '../../call/model';
import { useDispatch } from 'react-redux';

type Props = {
  call: GetCallResponse;
  view: SwitchGridListValue;
};

export const CallDropdown: FC<Props> = ({ view, call }) => {
  const dispatch = useDispatch();

  const { isPrivate } = call;

  const toggleVisibility = () => {
    if (!isPrivate) {
      dispatch(callModel.actions.setTogglingCallItem(call));
    } else {
      dispatch(
        callModel.actions.updateCallItem({
          id: call.id,
          data: { isPrivate: !isPrivate },
          isFromList: true,
        })
      );
    }
  };
  const handleEdit = () => {
    dispatch(callModel.actions.setEditingCallItem(call));
  };
  const handleDelete = () => {
    dispatch(callModel.actions.setDeletingCallItem(call));
  };

  const items = [
    {
      label: isPrivate ? 'Make public' : 'Make private',
      id: 'public',
      iconName: IconMap.Users02,
      iconWidth: 16,
      style: 'sm:hidden',
      onClick: toggleVisibility,
    },
    {
      label: 'Rename',
      id: 'rename',
      isSeparatedFromTop: true,
      iconName: IconMap.TextInput,
      iconWidth: 16,
      style: 'sm:hidden',
      onClick: handleEdit,
    },
    {
      label: 'Delete',
      id: 'delete',
      iconName: IconMap.Trash,
      iconWidth: 16,
      style: 'sm:hidden',
      onClick: handleDelete,
    },
  ];

  const buttonProps = useMemo(() => {
    if (view === 'grid') {
      return {
        variant: 'secondary-gray',
        size: 'sm',
        className:
          'bg-base-white/70 backdrop-blur-sm hover:border-gray-300 focus:outline-none',
      } as const;
    }

    return {
      variant: 'tertiary-gray',
      className: 'w-8 h-8 rounded-lg focus:outline-none',
    } as const;
  }, [view]);

  return (
    <Dropdown
      isModalMode={view === 'list'}
      preventEventBubbling
      listStyles="shadow-lg"
      triggerComponent={
        <DropdownMenu.Trigger asChild>
          <ButtonSquare {...buttonProps}>
            <Icon
              glyph={IconMap.DotsVertical}
              width={20}
              className={cn({ 'rotate-90': view === 'list' })}
            />
          </ButtonSquare>
        </DropdownMenu.Trigger>
      }
      items={items}
    />
  );
};
